(function () {
		// ====== CONFIG (edit these to suit) ======
		var LABEL = 'VIEW OTHER COMPETITIONS';
		var ITEMS = [
			{ target: '#product-media', text: 'Gallery' },
			{ target: '.cc-rich-text', text: 'Details' },
			{ target: '.cc-faq', text: 'How it works' },
			{ target: '.ai-quick-add-modal__content', text: 'Entry' },
			// { target: '.mobile-details button:nth-child(3)', text: 'Delivery' }
		];
		var BG = '#222222'; // requested brand background
		// =========================================
	
		// Tiny waiter as Convert may run before Shopify mounts the DOM
		var maxMs = 8000, step = 50, waited = 0;
		function waitFor(sel, cb){
			var el = document.querySelector(sel);
			if (el) return cb(el);
			if (waited >= maxMs) return;
			waited += step; setTimeout(function(){ waitFor(sel, cb); }, step);
		}
	
		waitFor('.media-gallery__viewer .media-viewer__item:nth-child(1)', function(host){
			if (!host || document.getElementById('cro-img-overlay')) return;

			// ---- Build Pill Navigation HTML ----
			var navHTML = ITEMS.map(function(it, idx){
				return [
					'<li class="pillnav__item">',
				'<a class="pillnav__link' + (idx === 0 ? ' pillnav__link--active' : '') + '" data-target="' + it.target + '" href="#">',
					it.text,
				'</a>',
					'</li>'
				].join('');
			}).join('');

			// Create wrapper for pillnav
			var navWrapper = document.createElement('div');
			navWrapper.className = 'pillnav-wrap';
			navWrapper.style.position = 'absolute';
			navWrapper.innerHTML = [
				'<nav class="pillnav" aria-label="Section navigation">',
					'<ul class="pillnav__list" role="list">', navHTML, '</ul>',
				'</nav>'
			].join('');
			var pillNav = navWrapper.querySelector('.pillnav');

			// Try to place in .media-gallery__viewer if it exists
			var gallery = document.querySelector('.media-gallery__viewer .media-viewer__item:nth-child(1)');
			var galleryContainer = document.querySelector('.media-gallery__viewer');
			if(galleryContainer) {
				// Remove any previous nav if present
				var oldWrap = galleryContainer.querySelector('.pillnav-wrap');
				if (oldWrap) {
					oldWrap.remove();
				}
				
				galleryContainer.appendChild(navWrapper);
				// gallery.style.display = 'flex';
				// gallery.style.justifyContent = 'flex-end';
				// gallery.style.alignItems = 'flex-start';
			} else {
				// fallback to announcement bar
				host.innerHTML = '';
				host.appendChild(navWrapper);
			}
			
			if (gallery) {

				// Add Feefo logo if not already present
				// if (!gallery.querySelector('.feefo-logo-abs')) {
				// 	var feefoImg = document.createElement('img');
				// 	feefoImg.src = 'https://api.feefo.com/api/logo?merchantidentifier=the-giveaway-guys';
				// 	feefoImg.alt = 'Feefo Reviews';
				// 	feefoImg.className = 'feefo-logo-abs';
				// 	gallery.appendChild(feefoImg);
				// }
				// Dynamically select badge image based on amount in <title>
				var badgeAmount = null;
				// Try to find the element with class .product_main_title
				var titleElement = document.querySelector('.product_main_title_cash');

				if (titleElement) {
					// Extract the full text content (including the span)
					var titleText = titleElement.textContent.trim();
					// Remove commas
					titleText = titleText.replace(/,/g, '');
					// Extract the amount — looks for £ followed by 3 to 6 digits
					var match = titleText.match(/£(\d{3,6})/);
					if (match) {
						badgeAmount = match[1];
					}
				}
				function formatBadgeAmount(amount) {
					var num = parseInt(amount, 10);
					if (isNaN(num)) return null;
					var shorthand = (num >= 1000) ? Math.floor(num / 1000).toString().padStart(2, '0') : num.toString().padStart(2, '0');
					return shorthand;
				}
				// Base Shopify files URL - replace with your store's actual base URL for files folder
				var shopifyFilesBaseUrl = 'https://cdn.shopify.com/s/files/1/0956/1492/7223/files/Win_Life_Comps_Cash-';
				var badgeUrl = null;
				if (badgeAmount) {
					var badgeShorthand = formatBadgeAmount(badgeAmount);
					if (badgeShorthand) {
						badgeUrl = shopifyFilesBaseUrl + badgeShorthand + '.png';
					}
				}
				// Add badge if not already present and badgeUrl is set
				if (badgeUrl && !gallery.querySelector('.badge-cash-abs')) {
					var badgeImg = document.createElement('img');
					badgeImg.src = badgeUrl;
					badgeImg.alt = badgeAmount ? ('£' + badgeAmount + ' Badge') : 'Cash Badge';
					badgeImg.className = 'badge-cash-abs';
					gallery.appendChild(badgeImg);
				}
			}


			document.addEventListener('click', function(e) {
				var link = e.target.closest('.pillnav__link');
				if (link) {
					e.preventDefault();
					// Remove active from all in the same nav
					var nav = link.closest('.pillnav');
					if (nav) {
						nav.querySelectorAll('.pillnav__link').forEach(function(l) {
							l.classList.remove('pillnav__link--active');
						});
					}
					// Add active to clicked
					link.classList.add('pillnav__link--active');
					var targetSel = link.getAttribute('data-target');
					if (targetSel) {
						var targetEl = document.querySelector(targetSel);
						if (targetEl) {
							if (targetEl.tagName === 'BUTTON') {
								if (!targetEl.classList.contains('active')) {
									targetEl.click();
								}
							}
							// Calculate offsetTop relative to document
							function getOffsetTopRelativeToDocument(el) {
								var top = 0;
								while (el) {
									top += el.offsetTop;
									el = el.offsetParent;
								}
								return top;
							}
							var scrollTop = getOffsetTopRelativeToDocument(targetEl) - 120;
							window.scrollTo({ top: scrollTop, behavior: 'smooth' });
						} else {
							console.warn('[pillnav debug] No element found for selector:', targetSel);
						}
					}
				}
			});

		});
	})();

	// Utility to wait for multiple selectors
	function waitForAll(selectors, cb) {
		var found = selectors.map(function(sel) { return document.querySelector(sel); });
		if (found.every(Boolean)) return cb.apply(null, found);
		setTimeout(function() { waitForAll(selectors, cb); }, 50);
	}

	// // Move .product-gallery-x.twcss-sticky below .draw-date-container once both exist
	// waitForAll(['.draw-date-container', '.product-gallery-x.twcss-sticky'], function(header, gallery) {
	//   if (header && gallery && header.parentNode) {
	//     header.parentNode.insertBefore(gallery, header.nextSibling);
	//   }
	// });

	// // Move .twcss-w-full below .draw-date-container once both exist
	// waitForAll(['.draw-date-container', '.twcss-w-full header'], function(drawDate, full) {
	//   if (drawDate && full && drawDate.parentNode) {
	//     drawDate.parentNode.insertBefore(full, drawDate.nextSibling);
	//   }
	// });


window.hashString = function (string) {
	if (typeof string === 'undefined') {
		return false;
	}
	let hash = 0,
		i,
		chr;
	if (string.length === 0) return hash;
	for (i = 0; i < string.length; i++) {
		chr = string.charCodeAt(i);
		hash = (hash << 5) - hash + chr;
		hash |= 0;
	}
	return hash;
};

window.countdown_timeout = window.countdown_timeout || {};

window.detectElement = (selector, callback) => {
	let selector_hash = hashString(selector);
	if (false === selector_hash) {
		return false;
	}
	if (typeof window.countdown_timeout[selector_hash] === 'undefined') {
		window.countdown_timeout[selector_hash] = null;
	}
	clearTimeout(window.countdown_timeout[selector_hash]);
	window.countdown_timeout[selector_hash] = setTimeout(() => {
		if (document.querySelectorAll(selector).length === 0) {
			window.detectElement(selector, callback);
			return false;
		} else {
			if (typeof callback === 'function') {
				callback();
			}
			return true;
		}
	}, 200);
};

(() => {
	
	const pillnav_clone = () => {
		
		const container_div       = document.createElement('div');
		const collection_existing = document.querySelector('.section--collection_bar');
		const collection_clone    = collection_existing.cloneNode(true);
		const pillnav_existing    = document.querySelector('.pillnav-wrap');
		const pillnav_clone       = pillnav_existing.cloneNode(true);
		const media_thumbs        = document.querySelector('.media-gallery .media-thumbs__item');
		
		container_div.classList.add('sticky-container');
		pillnav_clone.classList.add('pillnav-fixed');
		collection_existing.classList.add('collection-fixed');
		
		collection_existing.after(container_div);
		container_div.prepend(pillnav_clone);
		container_div.prepend(collection_existing);

		// const header = document.querySelector('.shopify-section-group-header-group');
		// const sticky_container = document.querySelector('.sticky-container');

		// const bottom = header.getBoundingClientRect().bottom;
		// sticky_container.style.top = `${bottom}px`;
		
		window.addEventListener('scroll', () => {
			const scrolled_past = ( media_thumbs.getBoundingClientRect().y < 0 );
			pillnav_clone.classList.toggle('active', scrolled_past);
		});
		
		
		const pillnav_links = pillnav_clone.querySelectorAll('.pillnav__link');
		
		let last_scroll_top = 0;
		
		const is_visible_observer = new IntersectionObserver(() => {
			
			let activeLink = null;
			const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
			const scrolling_down = scroll_top > last_scroll_top;
			last_scroll_top = Math.max(0 , scroll_top);
			
			
			pillnav_links.forEach((link) => {
				
				let targetSelector = link.getAttribute('data-target');
				if (targetSelector === '.mobile-details button:nth-child(1)') {
					targetSelector += ' + .accordion--content';
				}
				
				const target = document.querySelector(targetSelector);
				if (target) {
					const rect = target.getBoundingClientRect();
					
					if ( scrolling_down ) {
						if (rect.top <= window.innerHeight && rect.bottom > 0) {
							activeLink = link;
						}
					} else {
						if (rect.top <= window.innerHeight && rect.bottom > 0) {
							activeLink = link;
						}
						return;
					}
					
				}
			});
			
			pillnav_links.forEach((link) => {
				link.classList.remove('pillnav__link--active');
			});
			
			if (activeLink) {
				document.activeElement.blur();
				activeLink.classList.add('pillnav__link--active');
			}
			
		}, {
			rootMargin: '0px 0px 0px 0px',
			threshold: [0, 0.5, 1.0]
		});
		
		pillnav_links.forEach(link => {
			let targetSelector = link.getAttribute('data-target');
			
			if ( targetSelector === '.mobile-details button:nth-child(1)' ) {
				targetSelector += ' + .accordion--content';
			}
			
			const target = document.querySelector(targetSelector);
			
			if (target) {
				is_visible_observer.observe(target);
			}
		});
	   
		
	};
	
	if (!document.body.classList.contains('cro-tgg-21')) {
		
		document.body.classList.add('cro-tgg-21', 'cro-tgg-21--variant1');
		
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.type = 'text/css';
		link.href = `//cro.sculpt.digital/tgg-cro/tgg-21/tgg-21.css`;
		
		document.head.appendChild(link);
		
		detectElement('.pillnav-wrap', pillnav_clone);
		
		document.addEventListener('click', (evt) => {
			
			const collection_bar = document.querySelector('.sticky-container .collection__bar');
			if ( !collection_bar || !collection_bar.classList.contains('active') || evt.target.closest('.collection__bar') ) {
				return;
			}
			
			collection_bar.querySelector('.collection_bar_trigger').click();
			
		});
		
	}
	
})();